import React from 'react';

import { NavigationDesktop } from './NavigationDesktop/NavigationDesktop';
import { NavigationMobile } from './NavigationMobile/NavigationMobile';

export const Navigation = () => {
	return (
		<div data-testid="navigation">
			{/* rendering Navigations conditionally lead to flashing Navigation */}
			{/* https://github.com/gatsbyjs/gatsby/issues/15993 */}
			<NavigationMobile className={'flex xl:hidden'} />

			<div className="container absolute inset-x-0 top-8 hidden xl:flex">
				<NavigationDesktop className="w-full" />
			</div>
		</div>
	);
};
